import {
  Box,
  Button,
  Separator,
  SimpleGrid,
  Text,
  SimpleGridProps,
} from "@chakra-ui/react";
import { MdDownload } from "react-icons/md";
import { getInfoFile } from "@/utils/getIntoFile";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "../chakra/dialog";

export interface TableDataModalProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  content: {
    title?: string;
    items: {
      label?: string;
      isFile?: boolean;
      value?: string;
      customComponent?: React.ReactNode;
    }[];
    isCarousel?: boolean;
  }[];
  headerActions?: Array<{
    label: string;
    colorSchema: string;
    onClick: () => void;
  }>;
}

const TableDataModal: React.FC<TableDataModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
  headerActions,
}) => {
  const hasFilesStyles: SimpleGridProps = {
    display: "flex",
    overflowX: "auto",
  };
  return (
    <DialogRoot isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <DialogContent>
        <DialogCloseTrigger />
        <DialogHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pe={12}
        >
          <DialogTitle>{title}</DialogTitle>
          <Box display="flex" gap={3}>
            {headerActions?.map((action, index) => (
              <Button
                key={index}
                size="sm"
                colorPalette={action.colorSchema}
                onClick={action.onClick}
              >
                {action.label}
              </Button>
            ))}
          </Box>
        </DialogHeader>
        <DialogBody display="flex" flexDirection="column" gap={4}>
          {content.map((contentItem, index) => (
            <Box key={index} display="flex" flexDirection="column" gap={2}>
              {contentItem.items.length > 0 && (
                <SimpleGrid
                  columns={[2, null, 4]}
                  gap={4}
                  {...(contentItem.isCarousel && hasFilesStyles)}
                >
                  {contentItem.items.map((item, index) =>
                    item.isFile ? (
                      <Box
                        key={item.value}
                        borderWidth="1px"
                        borderColor="border"
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <a
                          href={item.value}
                          target={"_blank"}
                          rel="noreferrer"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "8rem",
                            minWidth: "8rem",
                            maxWidth: "10rem",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "1rem",
                          }}
                        >
                          <MdDownload size={42} />
                          <Text>{getInfoFile(item.value!).name}</Text>
                        </a>
                      </Box>
                    ) : (
                      <Box
                        key={index}
                        display="flex"
                        flexDirection="column"
                        gap={1}
                      >
                        {item.label && (
                          <Text
                            fontSize="xs"
                            fontWeight="semibold"
                            color="fg.muted"
                            textTransform="uppercase"
                            letterSpacing="wider"
                          >
                            {item.label}
                          </Text>
                        )}
                        {item.customComponent ? (
                          item.customComponent
                        ) : (
                          <Text>{item.value || "—"}</Text>
                        )}
                      </Box>
                    ),
                  )}
                </SimpleGrid>
              )}
              {index < content.length - 1 && <Separator mt={4} />}
            </Box>
          ))}
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};

export default TableDataModal;
